import { useState } from "react"
import api from "../../../../config";
import { useEffect } from "react";
import Filters from "./Filters";
import Table from "./Table";
import { getClients, getProducts, getWarehouses, objectToURLParams, showMessageError  } from "../../../../classes/functions";
import Modal from "react-modal";
import ModalDetails from "./Modals/Details";
import ModalFeatures from "./Modals/Feature";

export default function Reserved(){
    const [carrying, setCarrying] = useState(false);
    const [commitments, setCommitments] = useState([]);
    const [products, setProducts] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
    const [clients, setClients] = useState([]);
    const [details, setDetails] = useState([]);
    const [labels, setLabels] = useState([]);
    const [indexes, setIndexes] = useState([]);
    const [feature, setFeature] = useState([]);
    const [showModals, setShowModals] = useState({
        details: false,
        feature: false
    });
    const [searchListsToFilters, setSearchListsToFilters] = useState({
        produto: "",
        cliente: "",
        armazem: ""
    });
    const [filters, setFilters] = useState({
        produto: {
            value: "",
            label: ""
        },
        cliente: {
            value: "",
            label: ""
        },
        armazem: {
            value: "",
            label: ""
        },
        endereco_de: "",
        endereco_ate: "",
        palete_de: "",
        palete_ate: "",
        lote_de: "",
        lote_ate: "",
        serie_mac: ""
    });
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 50
    });
    
    function getReserveds(){
        let params = objectToURLParams(filters);

        api
        .get(`/api/balances/search?&page=${pagination.page}&limit=${pagination.limit}&${params}&property=codigo_produto&sortingType=DESC&relatorio=2`)
        .then((response) => {
            setCommitments(response?.data?.dados);
            setLabels(response?.data?.labels);
            setIndexes(response?.data?.indexes);
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            setCarrying(false);
        });
    }
    
    useEffect(() => {
        getReserveds();
    }, []);

    useEffect(() => {
        getProducts(searchListsToFilters.produto, setProducts, setCarrying);
    }, [searchListsToFilters.produto]);

    useEffect(() => {
        getClients(searchListsToFilters.cliente, setClients, setCarrying);
    }, [searchListsToFilters.cliente]);

    useEffect(() => {
        getWarehouses(searchListsToFilters.armazem, setWarehouses, setCarrying);
    }, [searchListsToFilters.armazem]);

    return (
        <>
            <Filters filters={{state: filters, setState: setFilters}} options={{produto: products, cliente: clients, armazem: warehouses}} getReserveds={getReserveds} searchListsToFilters={{state: searchListsToFilters, setState: setSearchListsToFilters}} />
            <br />
            <Table commitments={commitments} setDetails={setDetails} showModals={{state: showModals, setState: setShowModals}} labels={labels} indexes={indexes} feature={{state: feature, setState: setFeature}} />
            <ModalDetails details={details} showModals={{state: showModals, setState: setShowModals}} />
            <ModalFeatures feature={feature} showModals={{state: showModals, setState: setShowModals}} />
        </>
    )
}